import React from 'react';
import { Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const TableHeaderError = ({ error }) => (
  <div>
    <Icon
      size="big"
      name="times circle"
      color="red"
    />
    <FormattedMessage id="error.title" />
    <span className="aridhia-table-error-message">
      <FormattedMessage id="error.message" values={{ error }} />
    </span>
  </div>
);

export default TableHeaderError;
